import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-header_line",
  "use": "icon-header_line-usage",
  "viewBox": "0 0 2 14",
  "content": "<symbol viewBox=\"0 0 2 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-header_line\">\n<rect width=\"2\" height=\"14\" rx=\"1\" fill=\"#095540\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol